// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface History
 */
export interface History {
  /**
   *
   */
  ref: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  message: string;
  /**
   *
   */
  committedBy: User;
}

/**
 * Check if a given object implements the History interface.
 */
export function instanceOfHistory(value: object): value is History {
  if (!("ref" in value) || value["ref"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (!("message" in value) || value["message"] === undefined) return false;
  if (
    (!("committedBy" in (value as Record<string, any>)) &&
      !("committed_by" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["committedBy"] === undefined &&
      (value as Record<string, any>)["committed_by"] === undefined)
  )
    return false;
  return true;
}

export function HistoryFromJSON(json: any): History {
  return HistoryFromJSONTyped(json, false);
}

export function HistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): History {
  if (json == null) {
    return json;
  }
  return {
    ref: json["ref"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    message: json["message"],
    committedBy: UserFromJSON(json["committed_by"]),
  };
}

export function HistoryToJSON(json: any): History {
  return HistoryToJSONTyped(json, false);
}

export function HistoryToJSONTyped(
  value?: History | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    ref: value["ref"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    message: value["message"],
    committed_by: UserToJSON(value["committedBy"]),
  };
}
